module.exports = __webpack_public_path__ + "img/jlbz.d34b7427.png";